import React, { useMemo } from 'react';
import { useDefaultColor } from '../core';
import cuid from 'cuid';
import { SvgProps } from '../core';

interface CheckboxProps extends SvgProps {
  checked?: boolean;
}
const Checkbox: React.FC<CheckboxProps> = ({
  color,
  width = 30,
  height = 30,
  style,
  className,
  checked = false,
}) => {
  const resolvedColor = useDefaultColor(color);
  const maskId = useMemo(() => cuid(), []);

  return (
    <svg
      style={style}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
    >
      <mask id={maskId}>
        <rect x="0" y="0" width="30" height="30" fill="#fff" />
        {checked && (
          <path
            d="M6 16 L12 22 23 8"
            strokeLinejoin="round"
            stroke="#000"
            fill="none"
            strokeWidth={4}
          />
        )}
      </mask>
      <g
        stroke={resolvedColor}
        strokeWidth={4}
        fill={checked ? resolvedColor : 'none'}
      >
        <rect
          x="2"
          y="2"
          width="26"
          height="26"
          rx="4"
          mask={`url(#${maskId})`}
        />
      </g>
    </svg>
  );
};

export default Checkbox;
